let UTILS = require("../libs/utils.js");
var v7691;
var v7692;
module.exports = {
  id: "lms",
  name: "Last Man Standing",
  alias: "lms",
  endStats: ["sid", "name", "score", "kills", "deaths", "assists"],
  noRegen: true,
  noKick: true,
  teams: true,
  lives: 1,
  winCondition: function (game) {
    var vLN01182 = 0;
    var vLN01183 = 0;
    for (var vLN01184 = 0; vLN01184 < game.players.list.length; ++vLN01184) {
      if (game.players.list[vLN01184].lives > 0) {
        var v7693 = game.players.list[vLN01184].lives;
        if (game.players.list[vLN01184].team == 1) {
          vLN01182 += v7693;
        } else {
          vLN01183 += v7693;
        }
      }
    }
    if (vLN01182 > vLN01183) {
      return 1;
    } else {
      return 2;
    }
  },
  gameTime: 300000
};